/* lua.js generated code 0.3.0 */

var LoginBuffer = require("clover/loader/LoginBuffer")
GameProxy = xClass("GameProxy")
require("clover/utils/ShareProxy")
var fansclub = "http://fansclub.happyelements.com"
_fc_url = fansclub + "/fans/qa.php"
_qa_fc_url = fansclub + "/kefu/qa.php"
_kefu_url = fansclub + "/fans/faq.php"
var _proxy = null

// FIXME: defaultShareScene
var defaultShareScene = ShareScene.Session;
FAQTabConfig = table(
    [1, "kSheQu", table([1, "tag", 1], [1, "mainUrl", fansclub + "/fans/ff.php"])],
    [1, "kGongLue", table([1, "tag", 2], [1, "mainUrl", fansclub + "/fans/ff.php?route=stages"])],
    [1, "kKeFu", table([1, "tag", 3], [1, "mainUrl", fansclub + "/fans/faq.php"])]
)
var useNewFC = false
GameProxy.prototype.getIsUseNewFC = function () {
    var self = this
    return useNewFC
}
GameProxy.prototype.loadFCNew = function () {
    var self = this
    if (!ReachabilityUtil.getInstance().isNetworkAvailable()) {
        Toast.make("网络无连接")
        return 
    }
    cc.log("win32 invoked")
}
GameProxy.prototype.getParams = function () {
    var self = this
    var deviceOS = "android"
    var appId = "1002"
    var secret = "andridxxl!sx0fy13d2"
    if (__ANDROID && PlatformConfig.isQQPlatform()) { // android应用宝
        // appId = "1002"
        // secret = "yybxxl!1f0ft03ef"
    } else if (__IOS) {
        deviceOS = "ios"
        appId = "1001"
        secret = "iosxxl!23rj8945fc2d3"
    }
    var parameters = table()
    var metaInfo = he.MetaInfo.getInstance()
    parameters.app = appId
    parameters.os = deviceOS
    parameters.mac = metaInfo.getMacAddress() || ""
    parameters.model = metaInfo.getDeviceModel() || ""
    parameters.osver = metaInfo.getOsVersion() || ""
    parameters.udid = metaInfo.getUdid() || ""
    var network = "UNKNOWN"
    if (__ANDROID) {
        network = luajava.bindClass("com.happyelements.android.MetaInfo").getNetworkTypeName()
    } else if (__IOS) {
        network = oc.HeReachability.getNetWorkTypeName()
    }
    parameters.network = network || ""
    parameters.vip = 0
    parameters.src = "client"
    parameters.lang = "zh-Hans"
    parameters.pf = he.StartupConfig.getInstance().getPlatformName() || ""
    parameters.uuid = _G.kDeviceID || ""
    var user = UserManager.getInstance().user
    var profile = UserManager.getInstance().profile
    parameters.level = user.getTopLevelId() || ""
    var markData = UserManager.getInstance().mark
    var createTime = markData && markData.createTime || 0
    parameters.ct = tonumber(createTime) / 1000
    parameters.lt = PlatformConfig.getLoginTypeName()
    if (__ANDROID) {
        var pt = self.getDefaultSmsPayment()
        var ptName = "NOSIM"
        parameters.pt = tostring(ptName)
    } else if (__IOS) {
        parameters.pt = "apple"
    }
    parameters.gold = user.getCash() || "0"
    parameters.silver = user.getCoin() || "0"
    parameters.uver = ResourceLoader.getCurVersion() || ""
    parameters.uid = user.uid || ""
    var name = ""
    if (profile && profile.haveName()) {
        name = profile.getDisplayName()
    }
    parameters.name = name
    parameters.ver = _G.bundleVersion
    parameters.ts = os.time()
    parameters.ext = ""
    var roleId = UserManager.getInstance().inviteCode || ""
    parameters.roleid = tostring(roleId)
    var headUrl = "1"
    if (profile && profile.headUrl) {
        headUrl = profile.headUrl
    }
    parameters.roleavatar = headUrl
    var paramKeys = table()
    for (var k in parameters) {
        var v = parameters[k]
        table.insert(paramKeys, k)
    }
    table.sort(paramKeys)
    var md5Src = ""
    for (var _ in paramKeys) {
        var v = paramKeys[_]
        md5Src = md5Src + tostring(parameters[v])
    }
    var sig = he.HeMathUtils.md5(md5Src + secret)
    parameters.sig = sig
    return parameters
}
GameProxy.prototype.getUrl = function (url, params) {
    var self = this
    params = params || self.getParams()
    var qs = table()
    for (var k in params) {
        var v = params[k]
        table.insert(qs, k + "=" + he.HeDisplayUtil.urlEncode(tostring(v)))
    }
    if (string.find(url, "%?")) {
        return url + "&" + table.concat(qs, "&")
    } else {
        return url + "?" + table.concat(qs, "&")
    }
}
GameProxy.prototype.formatFcBridgeData = function (data) {
    function doDecode() {
        return JSON.parse(data)
    }
    var [success, ret] = pcall(doDecode)
    cc.log(">>>>formatFcBridgeData:", success, table.tostring(ret))
    if (success) {
        return ret
    } else {
        return null
    }
}
GameProxy.prototype.handleFcBridge = function (data) {
    var self = this
    var fData = self.formatFcBridgeData(data)
    if (type(fData) === "table") {
        if (fData.name === "updateUnread" && type(fData.param) === "table") {
            // local count = tonumber(fData.param.unread)
            // refreshFaqRedDot(count, nil, true)
            cc.log(">>>>>>>>>>>>>>>>>>>>>>>>handleFcBridge1")
        } else if (fData.name === "addIssue") {
            // local http = OpNotifyHttp.new()
            // http:load(OpNotifyType.kFAQAddIssue, 0)
            cc.log(">>>>>>>>>>>>>>>>>>>>>>>>handleFcBridge2")
        }
    }
}
GameProxy.prototype.getFaqReplayCountFromCookie = function () {
    var self = this
    var uid = UserManager.getInstance().uid
    // WARN: maybe multi result
    return Cookie.getInstance().read("faqRepayCount" + tostring(uid))
}
GameProxy.prototype.readFaqReplayCount = function () {
    var self = this
    var num = self.getFaqReplayCountFromCookie()
    if (num) {
        num = tonumber(num)
    } else {
        num = 0
    }
    return num
}
GameProxy.prototype.getLastFaqPingTimeFromCookie = function () {
    var self = this
    var uid = UserManager.getInstance().uid
    // WARN: maybe multi result
    return Cookie.getInstance().read("lastFaqPingTime" + tostring(uid))
}
GameProxy.prototype.setFaqReplayCountInCookie = function (count) {
    var self = this
    var uid = UserManager.getInstance().uid
    Cookie.getInstance().write("faqRepayCount" + tostring(uid), count)
    Cookie.getInstance().write("lastFaqPingTime" + tostring(uid), os.time())
}
// 请求客服系统提问的回复数
requestFaqReplayCount = function () {
    var userId = UserManager.getInstance().user.uid
    var url = fansclub + "/kefu/api/v1/updates.php"
    var lastFaqPingTime = "0"
    if (__ANDROID) {
        if (kUserLogin) {
            GspProxy.getFaqRepayCount(userId, lastFaqPingTime, url)
        }
    } else if (__IOS) {
        GspEnvironment.getCustomerSupportAgent().getFaqRepayCount_pingTime_urlStr(userId, lastFaqPingTime, url)
    }
}
GameProxy.prototype.tryRequestFaqReplayCount = function (isForce) {
    var self = this
    if (PrepackageUtil.isPreNoNetWork()) {
        return 
    }
    var latestAddIssueTime = UserManager.getInstance().userExtend.latestAddIssueTime
    latestAddIssueTime = tonumber(latestAddIssueTime) || 0
    var timeInSec = Localhost.timeInSec() - latestAddIssueTime
    if (timeInSec > 0 && timeInSec < 2592000) { // 30天内有过提问的玩家才需要获取消息数量
        var count = self.getFaqReplayCountFromCookie()
        var lastFaqPingTime = tonumber(FAQ.getLastFaqPingTimeFromCookie()) || 0
        if (isForce || !count || (os.time() - lastFaqPingTime > 1800)) {
            requestFaqReplayCount()
        }
    }
}
GameProxy.getInstance = function () {
    if (!_proxy) {
        _proxy = require("clover/utils/GameProxyH5").create()
        _proxy.init()
    }
    return _proxy
}
GameProxy.prototype.init = function () {
    var self = this
    self.wechatAppId = ""
    self.wechatAppKey = ""
    self.wechatPayAppId = ""
    // FIXME: initVerifiedScript
    // self.initVerifiedScript()
}
GameProxy.prototype.initPlatformConfig = function () {
    var self = this
    cc.log("initPlatformConfig")
}
// setting see also clover.config.CloverConst 
// SystemService.kLocation, ...
GameProxy.prototype.openSettings = function (setting) {
    var self = this
    printf("openSettings:%s", setting)
}
GameProxy.prototype.openUrl = function (url) {
    var self = this
    // body
}
//获取系统权限的状态
GameProxy.prototype.hasCamaraPermission = function () {
    var self = this
    return false
}
GameProxy.prototype.getCamaraPermissionstatus = function () {
    var self = this
    // return PrivilegeStatus.kDetermind
    return PrivilegeStatus.kOff
}
GameProxy.prototype.getNotificationPermissionStatus = function () {
    var self = this
    return PrivilegeStatus.kOk
}
GameProxy.prototype.getIsQQAvailable = function () {
    var self = this
    return true
}
GameProxy.prototype.exitGame = function () {
    var self = this
    var clock = os.clock()
    dc.dcUserLogout_81(tonumber(UserManager.getInstance().dataTemp.loginTime), tonumber(clock), tonumber(clock - UserManager.getInstance().dataTemp.loginTime), table())
    self.endToLua()
}
GameProxy.prototype.endToLua = function () {
    var self = this
    cc.Director.getInstance().endToLua()
}
GameProxy.prototype.restart = function () {
    var self = this
    self.exitGame()
}
GameProxy.prototype.onKeyBackClicked = function () { }
GameProxy.prototype.setUserId = function (userId) {
    var self = this
    userId = tostring(userId)
    self.userId = userId
    UserManager.getInstance().uid = userId
    cc.UserDefault.getInstance().setStringForKey("app_clover_userid", userId)
    cc.UserDefault.getInstance().flush()
    he.HeGameDefault.setUserId(userId)
    Cookie.getInstance().setUserId(userId)
}
GameProxy.prototype.setShareType = function (shareType) {
    var self = this
    self.shareType = shareType
    ShareProxy.setShareType(shareType)
}
GameProxy.prototype.getShareType = function () {
    var self = this
    return self.shareType
}
GameProxy.prototype.getOAuthType = function () {
    var self = this
    if (self.oauthType == null) {
        cc.log("?????????????")
        // WARN: maybe multi result
        return LoginBuffer.getInstance().getOAuthType()
    }
    cc.log("?????????????!!!!!!!!!!!!!!!!!!!!")
    return self.oauthType
}
GameProxy.prototype.getAuthConfig = function () {
    var self = this
    return table(
        [1, "btn", PlatformAuthEnum.kGuest],
        [1, "link", null],
        [1, "other", table()]
    )
}
GameProxy.prototype.getIsShowGuestInMain = function () {
    var self = this
    return self.isShowGuestInMain
}
GameProxy.prototype.setOauthType = function (oauthType) {
    var self = this
    self.oauthType = oauthType
}
GameProxy.prototype.setIsShowGuestInMain = function (value) {
    var self = this
    self.isShowGuestInMain = value
}
GameProxy.prototype.setOauthUI = function (oauthType) {
    var self = this
    self.oauthUI = oauthType
}
GameProxy.prototype.getOauthName = function () {
    var self = this
    var detail = PlatformAuthDetail[self.oauthType]
    if (detail) {
        return detail.name
    }
    return "unkown"
}
GameProxy.prototype.setExtraParams = function () { }
GameProxy.prototype.getFCCode = function () {
    var self = this
    // FIXME: multi result
    return ["win32", "", "", "UNKNOWN", ""]
}
GameProxy.prototype.getFCParams = function () {
    var self = this
    var [deviceOS, appId, secret, network, payType] = self.getFCCode()
    var parameters = table()
    var metaInfo = he.MetaInfo.getInstance()
    parameters.os = deviceOS
    parameters.app = appId
    parameters.network = network
    parameters.mac = metaInfo.getMacAddress()
    parameters.model = metaInfo.getDeviceModel()
    parameters.osver = metaInfo.getOsVersion()
    parameters.udid = metaInfo.getUdid()
    parameters.vip = 0
    parameters.src = "client"
    parameters.lang = "zh-Hans"
    parameters.pf = he.StartupConfig.getInstance().getPlatformName() || ""
    parameters.uuid = _G.kDeviceID || ""
    var user = UserManager.getInstance().user
    var profile = UserManager.getInstance().profile
    parameters.level = user.getTopLevelId()
    var markData = UserManager.getInstance().mark
    var createTime = markData && markData.createTime || 0
    parameters.ct = tonumber(createTime) / 1000
    parameters.lt = PlatformConfig.getLoginTypeName()
    parameters.pt = payType
    parameters.gold = user.getCash()
    parameters.silver = user.getCoin()
    parameters.uver = ResourceLoader.getCurVersion()
    parameters.uid = user.uid
    var name = ""
    if (profile && profile.haveName()) {
        name = profile.getDisplayName()
    }
    parameters.name = name
    parameters.ver = _G.bundleVersion
    parameters.ts = os.time()
    parameters.ext = ""
    var roleId = UserManager.getInstance().inviteCode || ""
    parameters.roleid = tostring(roleId)
    var headUrl = "1"
    if (profile && profile.headUrl) {
        headUrl = profile.headUrl
    }
    parameters.roleavatar = headUrl
    parameters.secret = secret
    var paramKeys = table()
    for (var k in parameters) {
        var v = parameters[k]
        table.insert(paramKeys, k)
    }
    table.sort(paramKeys)
    var md5Src = ""
    for (var _ in paramKeys) {
        var v = paramKeys[_]
        md5Src = md5Src + tostring(parameters[v])
    }
    var sig = he.HeMathUtils.md5(md5Src + secret)
    parameters.sig = sig
    return parameters
}
GameProxy.prototype.getFCURL = function (url, params) {
    var self = this
    var qs = table()
    for (var k in params) {
        var v = params[k]
        table.insert(qs, k + "=" + he.HeDisplayUtil.urlEncode(tostring(v)))
    }
    url = url || _fc_url
    if (string.find(url, "%?")) {
        return url + "&" + table.concat(qs, "&")
    } else {
        return url + "?" + table.concat(qs, "&")
    }
}
GameProxy.prototype.loadFC = function (url) {
    var self = this
    if (self.getIsUseNewFC()) {
        self.loadFCNew()
        return 
    }
    url = url || _fc_url
    cc.log("GameProxy load fc:" + url)
}
GameProxy.prototype.bindFc = function (url) {
    var self = this
    self.fcBindingUrl = url
}
GameProxy.prototype.getFcBindURL = function () {
    var self = this
    return self.fcBindingUrl || ""
}
GameProxy.prototype.defaultShareCallback = function () {
    var self = this
    he_log_info("create defaultShareCallback")
    return table(
        [1, "onSuccess", function (result) {
            he_log_info("default share success")
        }],
        [1, "onError", function (errCode, msg) {
            he_log_info("default share error, " + errCode)
        }],
        [1, "onCancel", function () {
            he_log_info("default share cancel")
        }]
    )
}
GameProxy.prototype.buildError = function (errorCode, extra) {
    var self = this
    return table([1, "errorCode", errorCode], [1, "msg", extra])
}
GameProxy.prototype.buildCallback = function (callback) {
    var self = this
    return callback
}
GameProxy.prototype.isWeChatInstalled = function () {
    var self = this
    return true
}
GameProxy.prototype.isQQInstalled = function () {
    var self = this
    return false
}
GameProxy.prototype.getWeChatAppId = function () {
    var self = this
    return self.wechatAppId
}
GameProxy.prototype.getWeChatPayAppId = function () {
    var self = this
    return self.wechatPayAppId
}
//是否可以重复分享
GameProxy.prototype.isSupportDuplicateShare = function () {return true}
//-------------------------------------
// 分享相关  入口
//-------------------------------------
// 分享有大部分没有回调，导到业务逻辑不参正常重置
GameProxy.prototype.shareHookCallback = function (callback) {
    var self = this
    var hook = table()
    hook.called = false
    hook.onSuccess = function (code, msg, data) {
        if (!hook.called && callback && callback.onSuccess) {
            hook.called = true
            callback.onSuccess(code, msg, data)
            if (window.mqq && window.OPEN_DATA.qua.app == 'WX'){
                require("activity/QQLive/QQLiveSharePanel").closePanel()
            }
        }
    }
    hook.onError = function (errCode, msg) {
        if (!hook.called && callback && callback.onError) {
            hook.called = true
            callback.onError(errCode, msg)
            if (window.mqq && window.OPEN_DATA.qua.app == 'WX'){
                require("activity/QQLive/QQLiveSharePanel").closePanel()
            }
        }
    }
    hook.onCancel = function () {
        if (!hook.called && callback && callback.onCancel) {
            hook.called = true
            callback.onCancel()
            if (window.mqq && window.OPEN_DATA.qua.app == 'WX'){
                require("activity/QQLive/QQLiveSharePanel").closePanel()
            }
        }
    }
    hook.onWxCallback = callback.onWxCallback
    // 去除超时
    // setTimeOut(function () {
    //     hook.onError(-100, "timeout")
    // }, 10)
    // WARN: maybe multi result
    return self.buildCallback(hook)
}
GameProxy.prototype.shareText = function (title, text, callback, shareScene) {
    var self = this
    shareScene = shareScene || defaultShareScene
    callback = callback || self.defaultShareCallback()
    var func = self.shareHookCallback(callback)
    ShareProxy.getInstance().shareText(title, text, func, shareScene)
}
//图片是本地图片
GameProxy.prototype.shareImage = function (title, text, thumb, image, callback, shareScene) {
    var self = this
    shareScene = shareScene || defaultShareScene
    callback = callback || self.defaultShareCallback()
    var func = self.shareHookCallback(callback)
    ShareProxy.getInstance().shareImage(title, text, thumb, image, func, shareScene)
}
//微信的接口定义：thumb是本地图片地址，image图片是网络上的图片
GameProxy.prototype.shareImageLink = function (title, text, thumb, image, callback, shareScene) {
    var self = this
    shareScene = shareScene || defaultShareScene
    callback = callback || self.defaultShareCallback()
    var func = self.shareHookCallback(callback)
    ShareProxy.getInstance().shareImageLink(title, text, thumb, image, func, shareScene)
}

/**
 * wxCb:微信公众号登入空间游戏，分享指引面板打开回调 
 * */
GameProxy.prototype.shareLinkJustCallback = function (onSuccess, onFail, onCancel, data, onWxCallback, needRealCalback = false) {
    var self = this
    data = data || {}
    let callback = {
        onSuccess : onSuccess,
        onError   : onFail,
        onCancel  : onCancel,
        onWxCallback: onWxCallback
    }
    if (data.srcapp){
        console.log("shareLinkJustCallback data.srcapp ",data.srcapp)
    }
    self.shareLink(data.textId, data.title, data.customContent || data.content || data.text, data.thumb, data.url, callback, data.shareScene, data.bg, needRealCalback)
}
//微信的接口定义：thumb是本地图片地址，image图片是网络上的图片
//qq的接口定义：thumb,image图片是网络上的图片qq
GameProxy.prototype.shareLink = function (textId, title, text, thumb, url, callback, shareScene, bg, needRealCalback = false) {
    var self = this
    shareScene = shareScene || defaultShareScene
    callback = callback || self.defaultShareCallback()
    var func = self.shareHookCallback(callback)

    //公众号登入空间版分享需要wxCallback
    if (window.mqq && window.OPEN_DATA.qua.app == 'WX')
    {
        let panel = require("activity/QQLive/QQLiveSharePanel")
        panel.popup(true)
        if (callback.onWxCallback){
            callback.onWxCallback()
        }
    }
    ShareProxy.getInstance().shareLink(textId, title, text, thumb, url, func, shareScene, bg, needRealCalback)
}
//现金支付购买,真正的调用支付，在这之前需要处理数据的在UserProduct里做
GameProxy.prototype.buyProduct = function (productId, extend, callback) {
    var self = this
    printf("buyProduct:%s extend:%s", productId, extend)
    if (callback && callback.onSuccess) {
        callback.onSuccess()
    }
}
GameProxy.prototype.initCMPaymentDecisionScript = function () {
    var self = this
    cc.log("initCMPaymentDecisionScript")
}
GameProxy.prototype.checkThirdPartPaymentEabled = function () {
    var self = this
    return false
}
GameProxy.prototype.getOperator = function () {
    var self = this
    return 0
}
GameProxy.prototype.getDefaultSmsPayment = function () {
    var self = this
    return null
}
GameProxy.prototype.getDCSession = function () {
    var self = this
    return ""
}
GameProxy.prototype.isNetworkAvailable = function () {
    var self = this
    return true
}
GameProxy.prototype.isEnableWIFI = function () {
    var self = this
    return true
}
GameProxy.prototype.isEnable3G = function () {
    var self = this
    return false
}
GameProxy.prototype.isNetworkReachable = function () {
    var self = this
    return true
}
GameProxy.prototype.isAnimalInstalled = function () {
    var self = this
    return false
}
GameProxy.prototype.openAnimal = function (param) {
    var self = this
    cc.log("do you want open animal?")
}
GameProxy.prototype.test = function () {
    var self = this
    cc.log("what do you want to test?")
}
//游戏起动，进入主场景后会调用，一些sdk会在这个时候初始化
GameProxy.prototype.lazyInit = function () { }
GameProxy.prototype.loadAndroidPaymentOrder = function (cfg) { }
GameProxy.prototype.getChinaMobileChannelId = function () {
    var self = this
    return ""
}
GameProxy.prototype.phoneCall = function (phoneNumer) { }
// @param goodsId 可选参数，
// @param payList 可选参数，一个由PaymentNames元素组成的数组。{"ingame", "alipay", "wechat"}
// return {default={"wechat"},all={"wechat", "alipay", "ingame"}}
GameProxy.prototype.getPaymentDicission = function (goodsId, payList) {
    var self = this
    if (!payList) {
        payList = PlatformConfig.getSupportPayment()
    }
    var xdefault = table()
    var all = table()
    if (table.includes(payList, "wechat")) {
        table.insert(xdefault, "wechat")
        table.insert(all, "wechat")
    }
    if (table.includes(payList, "alipay")) {
        table.insert(xdefault, "alipay")
        table.insert(all, "alipay")
    }
    if (table.includes(payList, "ingame")) {
        table.insert(all, "ingame")
        if ($len(xdefault) === 0) {
            table.insert(xdefault, "ingame")
        }
    }
    return table([1, "default", xdefault], [1, "all", all])
}
//callback function(flag) end, flag == true if ok, otherwith cancel.
// okLabel optional
// cancelLabel optional
GameProxy.prototype.alert = function (title, message, callback, okLabel, cancelLabel) {
    var self = this
    cc.log("show alert")
    if (callback) {
        callback(true)
    }
}
GameProxy.prototype.getProvince = function () {
    var self = this
    if (!self._province) {
        self._province = Cookie.getInstance().read(CookieKey.kLocationProvince)
    }
    return self._province
}
GameProxy.prototype.setProvince = function (value) {
    var self = this
    self._province = value
}
GameProxy.prototype.isLowDevice = function () {
    var self = this
    return false
}
GameProxy.prototype.refresh = function () {
    return false
}
GameProxy.prototype.refreshShareType = function () {
    return false
}
GameProxy.prototype.getDebugInfo = function () {
    return ""
}
GameProxy.prototype.isLowestDevice = function () {
    var self = this
    return false
}
var VerifiedStoragePath = "/verifiedStoragePath.ds"
GameProxy.prototype.changeVerifiedDecisionScript = function (luaString) {
    var self = this
    // body
    if (luaString && luaString !== "") {
        var func = loadstring(luaString)
        var [status, result] = pcall(func)
        if (status) {
            var encodeSrc = amf3.encode(luaString)
            var path = he.HeResPathUtils.getUserDataPath() + VerifiedStoragePath
            Localhost.safeWriteStringToFile(encodeSrc, path)
            self.updateVerifiedScript(func, result)
        }
    }
}
GameProxy.prototype.updateVerifiedScript = function (func, result) {
    var self = this
    // body
    self.verifiedFunc = func
    VerifiedManager.getInstance().setVerifiedMaintanceEnable(result)
}
GameProxy.prototype.initVerifiedScript = function () {
    var self = this
    // body
    var data = Localhost.readFromStorage(VerifiedStoragePath) || ""
    var storageSrc = string.trim(data)
    if (storageSrc && storageSrc !== "") {
        var func = loadstring(storageSrc)
        var [status, result] = pcall(func)
        if (status) {
            self.updateVerifiedScript(func, result)
        }
    }
}
GameProxy.prototype.onLoadingComplete = function() {
    
}
// function GameProxy:getVerifiedScriptFuncResult( ... )
//     -- body
//     if self.verifiedFunc then
//         return self.verifiedFunc()
//     end
// end
